import React, { useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/ingredientValidate';
import '../../../../css/Addingredient.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CreateIngredientContext } from "../createIngredient";

axios.defaults.baseURL = API;

function AddIngredient(props) {

    const {TempIngredient, setTempIngredient, gProductID, gProductName, gRetail_Price} = useContext(CreateIngredientContext);

    const handleInputChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
    };

     async function saveTutorial() {
        var c =0;
        for (var i=0; i < TempIngredient.length; i++) {
            if (TempIngredient[i].ProductID == gProductID) {
                if(Number(TempIngredient[i].Size) + Number(values.Size) > 0)
                {
                    TempIngredient[i].Size = Number(TempIngredient[i].Size) + Number(values.Size);
                } else {
                    TempIngredient.splice(i, 1);
                }
                c = 1;
                break;
            }
        }  
        if(c == 0){
            var datalist = {
                ProductID: gProductID,
                LaoName: gProductName,
                Retail_Price: gRetail_Price,
                Size: values.Size,
            }
            TempIngredient.push(datalist);
        }
        localStorage.setItem("TempIngredient", JSON.stringify(TempIngredient));
        handleChange("Size", "");
        props.onClick(false);
    };

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);
 
    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="AddIngredient">
            <div className="Ingredientcontent">
                <div className="IngredientHeader">
                    <span>{gProductName}</span>
                </div>
                <div className="IngredientBody">
                   <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ປະລິມານ</span>
                                <input className={`input form-control ${errors.Size && 'is-invalid'}`} type="text" name="Size" onChange={(e) => handleInputChange(e)} value={values.Size || ''}  required />
                                {errors.Size && (
                                    <p className="invalid-feedback">{errors.Size}</p>
                                )}
                            </div> 
                        </div>
                        <div className="Ingredientfooter">
                            <button type="submit" className="btn btn-primary">
                                ເພີ່ມ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddIngredient;
